import { PointsListCheckboxGroupPointType } from 'application/components/PointItemContent/types';

import { DeviceTypesInFlow } from '../types';

export type SelectedPoint = {
  id: PointsListCheckboxGroupPointType['id'];
  address?: PointsListCheckboxGroupPointType['address'];
  title?: PointsListCheckboxGroupPointType['title'];
  device?: {
    type: DeviceTypesInFlow;
    requiredVersionUrl?: string;
  };
  isEnabled?: boolean;
};

export interface StreamBindSuccessModalProps {
  selectedPoints?: SelectedPoint[];
  successCallback?: () => void;
}

export interface UseStreamBindSuccessModalViewModel {
  selectedPoints: SelectedPoint[];
  showWebPlayerButton: boolean;
  isAtLeastOnePointWithoutDevice: boolean;
  onShowPointsPage: () => void;
  onShowWebPlayerClick: () => void;
  onClose: () => void;
}

export enum StreamBindSuccessModalType {
  SELECT_WAVE = 'device_bind',
  OPEN_WEBPLAYER = 'web_player',
  COMPLETED = 'completed',
}
